import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  tbody {
    position: relative;
  }

  /* td, */
  th {
    border: 1px solid #ddd;
  }
`;

export const TableHeader = styled.thead`
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 9999;

  tr {
    color: ${({ theme }) => theme.colors.white};

    th {
      padding: 10px;
    }
  }
`;

export const BusinessSelect = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 7px;
  p {
    text-align: end;
    margin-right: 10px;
    font-size: 12px;
  }
`;

export const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  p {
    text-align: left;
    padding: 10px 10px 10px 10px;
    font-size: 12px;
  }
`;

export const SecondRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const StatusSelect = styled.div`
  display: flex;
  flex-direction: row;
  p {
    font-size: 12px;
  }
`;

export const DurationCell = styled.th`
  border: none;
  margin-left: 10px;
  font-weight: 400;
  .form-control {
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.lightGrey2} !important;
    font-size: 13px;
    width: 65%;
  }
`;

export const DateTimePickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  p {
    text-align: end;
    width: 30px;
    margin-right: 10px;
    font-size: 12px;
  }
`;

export const dateTimeTextFieldStyle = {
  width: '96px',
  height: '17px',
  '.MuiInputBase-root': {
    height: '17px',
  },
  '.MuiOutlinedInput-input': {
    padding: '0px',
    fontSize: '12px',
    lineHeight: '16px',
    marginLeft: '5px',
  },
  '.MuiInput-underline:after': {
    borderBottomColor: 'black',
  },
  '& .MuiOutlinedInput-root ': {
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
  },
  '.MuiButtonBase-root': {
    padding: '2px',
    '.MuiSvgIcon-root': {
      width: '15px',
      height: '15px',
    },
  },
};

export const timeTextFieldStyle = {
  width: '66px',
  height: '17px',
  '.MuiInputBase-root': {
    height: '17px',
  },
  '.MuiOutlinedInput-input': {
    padding: '0px',
    fontSize: '12px',
    lineHeight: '16px',
    marginLeft: '5px',
  },
  '.MuiInput-underline:after': {
    borderBottomColor: 'black',
  },
  '& .MuiOutlinedInput-root ': {
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
  },
  '.MuiButtonBase-root': {
    padding: '2px',
    '.MuiSvgIcon-root': {
      width: '15px',
      height: '15px',
    },
  },
};
